(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesDialogController', TabDevicesDialogController);

    TabDevicesDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'TabDevices', 'TabDevicesTypes', 'TabObjectTypes', 'TabSchedule', '$state'];

    function TabDevicesDialogController ($timeout, $scope, $stateParams, entity, TabDevices, TabDevicesTypes, TabObjectTypes, TabSchedule, $state) {
        var vm = this;
        vm.tabDevices = entity;
        vm.tabdevicestypes = TabDevicesTypes.query({size: 1000});
        vm.tabobjecttypes = TabObjectTypes.query();
        vm.tabschedules = TabSchedule.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabDevicesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-devices');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabDevices.id !== null) {
                TabDevices.update(vm.tabDevices, onSaveSuccess, onSaveError);
            } else {
                TabDevices.save(vm.tabDevices, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('tab-devices');
        };
    }
})();
